import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { selectSearchTerm, setSearch } from "./searchSlice";

const SearchBar = () => {
  const dispatch = useDispatch();
  const searchTerm = useSelector(selectSearchTerm);

  const handleChange = (e) => {
    dispatch(setSearch(e.target.value));
  };

  return (
    <div>
      <form>
        <input
          type="text"
          placeholder="Search by typing"
          onChange={handleChange}
          value={searchTerm}
        />
      </form>
    </div>
  );
};

export default SearchBar;
